module.exports = __webpack_public_path__ + "img/category_camping.5f14992.png";